const ticketsOverview = [
    {
        datetime: "2024-05-03 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-04 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-05 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-06 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-07 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-08 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 0,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 173,
            points: 0,
        },
    },
    {
        datetime: "2024-05-09 00:00:00",
        todo: {
            issues: 5,
            points: 0,
        },
        inProgress: {
            issues: 5,
            points: 0,
        },
        done: {
            issues: 2,
            points: 0,
        },
        todoAll: {
            issues: 5,
            points: 0,
        },
        inProgressAll: {
            issues: 5,
            points: 0,
        },
        doneAll: {
            issues: 175,
            points: 0,
        },
    },
];

const timeStateDuration = [
    {
        datetime: "2024-08-26 00:00:00",
        states: {
            "IN PROD": 3816390.6,
            "In Progress": 2726572,
            "IN SIT": 533.2874,
            "MERGED TO MASTER": 308629.08042857144,
            "Ready For QA": 983464,
            "To Do": 4791339.5,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 5920061,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 2993574,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 2632437,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 2632443,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 6257165,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 2632449,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 2632446,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 2632440,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 7198459,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 2632432,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-978",
                from: "2024-08-01T12:37:07",
                until: "2024-09-18T14:06:53",
                duration: 2726572,
                overallDuration: 4152586,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-30T18:48:48",
                until: "2024-08-30T19:13:00",
                duration: 1452,
                overallDuration: 1452,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-30T19:13:00",
                until: "2024-08-30T19:13:00.331",
                duration: 0.331,
                overallDuration: 0.331,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-30T18:17:01.894",
                until: "2024-08-30T18:33:50",
                duration: 1008.106,
                overallDuration: 1008.106,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-30T18:06:01",
                until: "2024-08-30T18:07:33",
                duration: 92,
                overallDuration: 92,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-30T17:44:11",
                until: "2024-08-30T17:46:05",
                duration: 114,
                overallDuration: 114,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-30T18:33:50",
                until: "2024-08-30T18:48:48",
                duration: 898,
                overallDuration: 898,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-30T18:07:33",
                until: "2024-08-30T18:17:01",
                duration: 568,
                overallDuration: 568,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-20T12:46:38",
                until: "2024-08-30T17:44:11",
                duration: 881853,
                overallDuration: 881853,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-08-20T14:22:10",
                until: "2024-09-11T19:00:04",
                duration: 1078669,
                overallDuration: 1917474,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-30T17:46:05",
                until: "2024-08-30T18:06:01",
                duration: 1196,
                overallDuration: 1196,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-30T18:17:01",
                until: "2024-08-30T18:17:01.894",
                duration: 0.894,
                overallDuration: 0.894,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-30T19:13:00.331",
                until: "2024-09-02T10:39:32",
                duration: 197218.669,
                overallDuration: 228391.669,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-08-21T16:48:55",
                until: "2024-09-11T18:59:34",
                duration: 983464,
                overallDuration: 1822239,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-06-20T17:42:12",
                until: "2024-09-11T10:25:28",
                duration: 6337067,
                overallDuration: 7144996,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-07-26T12:26:27",
                until: "2024-09-10T16:09:03",
                duration: 3245612,
                overallDuration: 3987756,
                state: "To Do",
            },
        ],
    },
    {
        datetime: "2024-09-02 00:00:00",
        states: {
            "IN PROD": 4421190.6,
            "In Progress": 3331372,
            "IN SIT": 11250.047,
            "MERGED TO MASTER": 264915.2495555556,
            "Ready For QA": 1588264,
            "To Do": 3597501,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 3237249,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 3237246,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 3237243,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 3237232,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 6861965,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 3237237,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 7803259,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 3598374,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 6524861,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 3237240,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-978",
                from: "2024-08-01T12:37:07",
                until: "2024-09-18T14:06:53",
                duration: 3331372,
                overallDuration: 4152586,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T16:50:45",
                until: "2024-09-03T15:38:22",
                duration: 82057,
                overallDuration: 82057,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T16:22:56",
                until: "2024-09-02T16:50:19",
                duration: 1643,
                overallDuration: 1643,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T14:04:34",
                until: "2024-09-02T14:04:34.658",
                duration: 0.658,
                overallDuration: 0.658,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T14:11:06",
                until: "2024-09-02T14:11:06.371",
                duration: 0.371,
                overallDuration: 0.371,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T14:59:25.503",
                until: "2024-09-02T16:22:38",
                duration: 4992.497,
                overallDuration: 4992.497,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T14:06:51",
                until: "2024-09-02T14:11:06",
                duration: 255,
                overallDuration: 255,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T10:39:32.269",
                until: "2024-09-02T14:04:34",
                duration: 12301.731,
                overallDuration: 12301.731,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T16:22:38",
                until: "2024-09-02T16:22:38.022",
                duration: 0.022,
                overallDuration: 0.022,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T16:50:19",
                until: "2024-09-02T16:50:19.144",
                duration: 0.144,
                overallDuration: 0.144,
                state: "IN SIT",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-08-30T19:13:00.331",
                until: "2024-09-02T10:39:32",
                duration: 228391.669,
                overallDuration: 228391.669,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-08-20T14:22:10",
                until: "2024-09-11T19:00:04",
                duration: 1683469,
                overallDuration: 1917474,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T14:59:25",
                until: "2024-09-02T14:59:25.503",
                duration: 0.503,
                overallDuration: 0.503,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-03T15:38:22",
                until: "2024-09-14T17:55:47",
                duration: 469297,
                overallDuration: 958645,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T16:50:19.144",
                until: "2024-09-02T16:50:45",
                duration: 25.856,
                overallDuration: 25.856,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T14:04:34.658",
                until: "2024-09-02T14:06:51",
                duration: 136.342,
                overallDuration: 136.342,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T10:39:32",
                until: "2024-09-02T10:39:32.269",
                duration: 0.269,
                overallDuration: 0.269,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T16:22:38.022",
                until: "2024-09-02T16:22:56",
                duration: 17.978,
                overallDuration: 17.978,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-02T14:11:06.371",
                until: "2024-09-02T14:59:25",
                duration: 2898.629,
                overallDuration: 2898.629,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-08-21T16:48:55",
                until: "2024-09-11T18:59:34",
                duration: 1588264,
                overallDuration: 1822239,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-06-20T17:42:12",
                until: "2024-09-11T10:25:28",
                duration: 6941867,
                overallDuration: 7144996,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/HR-31",
                from: "2024-09-02T10:49:02",
                until: "2024-09-02T10:52:46",
                duration: 224,
                overallDuration: 224,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-07-26T12:26:27",
                until: "2024-09-10T16:09:03",
                duration: 3850412,
                overallDuration: 3987756,
                state: "To Do",
            },
        ],
    },
    {
        datetime: "2024-09-09 00:00:00",
        states: {
            "IN PROD": 3951716.076923077,
            "In Progress": 918309,
            "MERGED TO MASTER": 611505.6666666666,
            "Ready For QA": 1019483,
            "To Do": 1868258.1666666667,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T18:59:49",
                until: "2024-11-22T11:57:57",
                duration: 370810,
                overallDuration: 6199088,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 3842049,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 3842046,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 7466765,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 3842040,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 7129661,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 8408059,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 4203174,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 3842037,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T19:00:01",
                until: "2024-11-22T11:58:00",
                duration: 370798,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 3842032,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 3842043,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-09-11T19:00:04",
                until: "2024-11-22T11:58:03",
                duration: 370795,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-11T11:51:23",
                until: "2024-09-12T16:10:20",
                duration: 101937,
                overallDuration: 101937,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-09-10T16:23:17",
                until: "2024-09-17T17:28:24",
                duration: 466602,
                overallDuration: 608707,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-978",
                from: "2024-08-01T12:37:07",
                until: "2024-09-18T14:06:53",
                duration: 3936172,
                overallDuration: 4152586,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-12T13:40:46",
                until: "2024-09-13T13:47:52",
                duration: 86826,
                overallDuration: 86826,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-09-10T16:09:03",
                until: "2024-09-10T16:09:11",
                duration: 8,
                overallDuration: 8,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-09-10T16:09:11",
                until: "2024-10-16T12:46:51",
                duration: 467448,
                overallDuration: 3098260,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T10:25:28",
                until: "2024-09-11T18:59:49",
                duration: 30861,
                overallDuration: 30861,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-12T16:10:20",
                until: "2024-09-16T15:28:49",
                duration: 294579,
                overallDuration: 343109,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T18:59:34",
                until: "2024-09-11T19:00:01",
                duration: 27,
                overallDuration: 27,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-980",
                from: "2024-09-03T15:38:22",
                until: "2024-09-14T17:55:47",
                duration: 958645,
                overallDuration: 958645,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-08-20T14:22:10",
                until: "2024-09-11T19:00:04",
                duration: 1917474,
                overallDuration: 1917474,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-08-21T16:48:55",
                until: "2024-09-11T18:59:34",
                duration: 1822239,
                overallDuration: 1822239,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-13T13:47:52",
                until: "2024-09-16T15:28:41",
                duration: 216727,
                overallDuration: 265249,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-09-10T16:09:48",
                until: "2024-09-10T16:23:17",
                duration: 809,
                overallDuration: 809,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-07-26T12:26:27",
                until: "2024-09-10T16:09:03",
                duration: 3987756,
                overallDuration: 3987756,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-06-20T17:42:12",
                until: "2024-09-11T10:25:28",
                duration: 7144996,
                overallDuration: 7144996,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-11T11:51:17",
                until: "2024-09-11T11:51:23",
                duration: 6,
                overallDuration: 6,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-986",
                from: "2024-09-14T22:03:17",
                until: "2024-09-14T22:03:28",
                duration: 11,
                overallDuration: 11,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-11T16:34:35",
                until: "2024-09-12T13:40:46",
                duration: 75971,
                overallDuration: 75971,
                state: "To Do",
            },
        ],
    },
    {
        datetime: "2024-09-16 00:00:00",
        states: {
            "IN PROD": 4023150.1333333333,
            "In Progress": 859284,
            "MERGED TO MASTER": 419440.6,
            "Ready For QA": 344933,
            "To Do": 1351.5,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 4446840,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 4446846,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 8071565,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-16T15:28:49",
                until: "2024-11-22T11:58:12",
                duration: 556270,
                overallDuration: 5779763,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 7734461,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 9012859,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 4807974,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 4446837,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T19:00:01",
                until: "2024-11-22T11:58:00",
                duration: 975598,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 4446832,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 4446843,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-09-11T19:00:04",
                until: "2024-11-22T11:58:03",
                duration: 975595,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T18:59:49",
                until: "2024-11-22T11:57:57",
                duration: 975610,
                overallDuration: 6199088,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-16T15:28:46",
                until: "2024-11-22T11:58:05",
                duration: 556273,
                overallDuration: 5779759,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 4446849,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-09-10T16:23:17",
                until: "2024-09-17T17:28:24",
                duration: 608707,
                overallDuration: 608707,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-09-20T11:59:20",
                until: "2024-09-20T13:07:33",
                duration: 4093,
                overallDuration: 4093,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-18T13:06:59",
                until: "2024-09-18T14:06:55",
                duration: 3596,
                overallDuration: 3596,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-978",
                from: "2024-08-01T12:37:07",
                until: "2024-09-18T14:06:53",
                duration: 4152586,
                overallDuration: 4152586,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-09-18T16:33:43",
                until: "2024-10-01T18:06:11",
                duration: 379576,
                overallDuration: 1128748,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-18T14:08:07",
                until: "2024-09-18T16:07:13",
                duration: 7146,
                overallDuration: 7146,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-09-20T13:07:33",
                until: "2024-10-16T12:47:00",
                duration: 219146,
                overallDuration: 2245167,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-12T16:10:20",
                until: "2024-09-16T15:28:49",
                duration: 343109,
                overallDuration: 343109,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-09-10T16:09:11",
                until: "2024-10-16T12:46:51",
                duration: 1072248,
                overallDuration: 3098260,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-09-17T17:28:24",
                until: "2024-10-16T12:46:55",
                duration: 462695,
                overallDuration: 2488711,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-16T15:28:41",
                until: "2024-09-16T15:28:46",
                duration: 5,
                overallDuration: 5,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-18T16:07:13",
                until: "2024-09-23T10:54:12",
                duration: 381166,
                overallDuration: 413219,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-13T13:47:52",
                until: "2024-09-16T15:28:41",
                duration: 265249,
                overallDuration: 265249,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-18T14:06:55",
                until: "2024-09-23T10:54:08",
                duration: 388384,
                overallDuration: 420433,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-18T14:07:30",
                until: "2024-09-18T14:08:07",
                duration: 37,
                overallDuration: 37,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-09-18T16:33:39",
                until: "2024-09-18T16:33:43",
                duration: 4,
                overallDuration: 4,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-09-20T11:56:24",
                until: "2024-09-20T11:59:20",
                duration: 176,
                overallDuration: 176,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-18T11:40:30",
                until: "2024-09-18T13:06:59",
                duration: 5189,
                overallDuration: 5189,
                state: "To Do",
            },
        ],
    },
    {
        datetime: "2024-09-23 00:00:00",
        states: {
            "IN PROD": 4627950.133333334,
            "In Progress": 600454.5,
            "MERGED TO MASTER": 942797.4,
            "Ready For QA": 416826,
            "To Do": 9388.5,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 5051632,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 5051646,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 8676365,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-16T15:28:49",
                until: "2024-11-22T11:58:12",
                duration: 1161070,
                overallDuration: 5779763,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 5051640,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 8339261,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 9617659,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 5412774,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 5051637,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T19:00:01",
                until: "2024-11-22T11:58:00",
                duration: 1580398,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 5051643,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-09-11T19:00:04",
                until: "2024-11-22T11:58:03",
                duration: 1580395,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T18:59:49",
                until: "2024-11-22T11:57:57",
                duration: 1580410,
                overallDuration: 6199088,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-16T15:28:46",
                until: "2024-11-22T11:58:05",
                duration: 1161073,
                overallDuration: 5779759,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 5051649,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-09-18T16:33:43",
                until: "2024-10-01T18:06:11",
                duration: 984376,
                overallDuration: 1128748,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-09-27T13:51:06",
                until: "2024-10-01T19:14:56",
                duration: 216533,
                overallDuration: 365030,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-09-17T17:28:24",
                until: "2024-10-16T12:46:55",
                duration: 1067495,
                overallDuration: 2488711,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-09-10T16:09:11",
                until: "2024-10-16T12:46:51",
                duration: 1677048,
                overallDuration: 3098260,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-23T10:54:08",
                until: "2024-11-13T17:13:53",
                duration: 572751,
                overallDuration: 4432785,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-23T10:54:12",
                until: "2024-11-13T17:13:55",
                duration: 572747,
                overallDuration: 4432783,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-09-20T13:07:33",
                until: "2024-10-16T12:47:00",
                duration: 823946,
                overallDuration: 2245167,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-18T14:06:55",
                until: "2024-09-23T10:54:08",
                duration: 420433,
                overallDuration: 420433,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-18T16:07:13",
                until: "2024-09-23T10:54:12",
                duration: 413219,
                overallDuration: 413219,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-09-27T13:51:01",
                until: "2024-09-27T13:51:06",
                duration: 5,
                overallDuration: 5,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-991",
                from: "2024-09-24T09:05:18",
                until: "2024-09-24T14:18:10",
                duration: 18772,
                overallDuration: 18772,
                state: "To Do",
            },
        ],
    },
    {
        datetime: "2024-09-30 00:00:00",
        states: {
            "IN PROD": 5232750.133333334,
            "In Progress": 495982.75,
            "MERGED TO MASTER": 1236388.2857142857,
            "Ready For QA": 392853,
            "To Do": 2959,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-16T15:28:46",
                until: "2024-11-22T11:58:05",
                duration: 1765873,
                overallDuration: 5779759,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T18:59:49",
                until: "2024-11-22T11:57:57",
                duration: 2185210,
                overallDuration: 6199088,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 9281165,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 5656443,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-09-11T19:00:04",
                until: "2024-11-22T11:58:03",
                duration: 2185195,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-16T15:28:49",
                until: "2024-11-22T11:58:12",
                duration: 1765870,
                overallDuration: 5779763,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 5656437,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 5656440,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 8944061,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 10222459,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 6017574,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 5656432,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 5656446,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T19:00:01",
                until: "2024-11-22T11:58:00",
                duration: 2185198,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 5656449,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-02T12:38:23",
                until: "2024-10-02T12:52:26",
                duration: 843,
                overallDuration: 843,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-993",
                from: "2024-10-01T10:04:49",
                until: "2024-10-12T13:14:12",
                duration: 489310,
                overallDuration: 961763,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-09-27T13:51:06",
                until: "2024-10-01T19:14:56",
                duration: 365030,
                overallDuration: 365030,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-09-18T16:33:43",
                until: "2024-10-01T18:06:11",
                duration: 1128748,
                overallDuration: 1128748,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-09-17T17:28:24",
                until: "2024-10-16T12:46:55",
                duration: 1672295,
                overallDuration: 2488711,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-09-20T13:07:33",
                until: "2024-10-16T12:47:00",
                duration: 1428746,
                overallDuration: 2245167,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-10-01T18:06:11",
                until: "2024-11-13T17:13:46",
                duration: 460428,
                overallDuration: 3715655,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-23T10:54:12",
                until: "2024-11-13T17:13:55",
                duration: 1177547,
                overallDuration: 4432783,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-23T10:54:08",
                until: "2024-11-13T17:13:53",
                duration: 1177551,
                overallDuration: 4432785,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-09-10T16:09:11",
                until: "2024-10-16T12:46:51",
                duration: 2281848,
                overallDuration: 3098260,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-10-01T19:14:56",
                until: "2024-11-13T17:13:50",
                duration: 456303,
                overallDuration: 3711534,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-02T12:52:26",
                until: "2024-10-15T12:11:04",
                duration: 392853,
                overallDuration: 1120718,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-993",
                from: "2024-10-01T08:28:45",
                until: "2024-10-01T10:04:49",
                duration: 5764,
                overallDuration: 5764,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-02T12:35:49",
                until: "2024-10-02T12:38:23",
                duration: 154,
                overallDuration: 154,
                state: "To Do",
            },
        ],
    },
    {
        datetime: "2024-10-07 00:00:00",
        states: {
            "IN PROD": 5837550.133333334,
            "In Progress": 961763,
            "MERGED TO MASTER": 1627583.125,
            "Ready For QA": 997653,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 6261243,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 10827259,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 6261232,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 6622374,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 6261249,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-16T15:28:46",
                until: "2024-11-22T11:58:05",
                duration: 2370673,
                overallDuration: 5779759,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T18:59:49",
                until: "2024-11-22T11:57:57",
                duration: 2790010,
                overallDuration: 6199088,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-09-11T19:00:04",
                until: "2024-11-22T11:58:03",
                duration: 2789995,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T19:00:01",
                until: "2024-11-22T11:58:00",
                duration: 2789998,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 6261237,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 6261246,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 9885965,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-16T15:28:49",
                until: "2024-11-22T11:58:12",
                duration: 2370670,
                overallDuration: 5779763,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 6261240,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 9548861,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-993",
                from: "2024-10-01T10:04:49",
                until: "2024-10-12T13:14:12",
                duration: 961763,
                overallDuration: 961763,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-23T10:54:08",
                until: "2024-11-13T17:13:53",
                duration: 1782351,
                overallDuration: 4432785,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-23T10:54:12",
                until: "2024-11-13T17:13:55",
                duration: 1782347,
                overallDuration: 4432783,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-09-20T13:07:33",
                until: "2024-10-16T12:47:00",
                duration: 2033546,
                overallDuration: 2245167,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-09-17T17:28:24",
                until: "2024-10-16T12:46:55",
                duration: 2277095,
                overallDuration: 2488711,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-09-10T16:09:11",
                until: "2024-10-16T12:46:51",
                duration: 2886648,
                overallDuration: 3098260,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-10-01T18:06:11",
                until: "2024-11-13T17:13:46",
                duration: 1065228,
                overallDuration: 3715655,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-993",
                from: "2024-10-12T13:14:12",
                until: "2024-10-16T12:46:58",
                duration: 132347,
                overallDuration: 343966,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-10-01T19:14:56",
                until: "2024-11-13T17:13:50",
                duration: 1061103,
                overallDuration: 3711534,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-02T12:52:26",
                until: "2024-10-15T12:11:04",
                duration: 997653,
                overallDuration: 1120718,
                state: "Ready For QA",
            },
        ],
    },
    {
        datetime: "2024-10-14 00:00:00",
        states: {
            "IN PROD": 4930057.95,
            "In Progress": 132121.5,
            "MERGED TO MASTER": 1677227.3,
            "Ready For QA": 669096,
            "To Do": 44201.5,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-16T15:28:49",
                until: "2024-11-22T11:58:12",
                duration: 2975470,
                overallDuration: 5779763,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-16T12:47:04",
                until: "2024-11-22T11:58:32",
                duration: 393175,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 6866046,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 10490765,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 6866040,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 10153661,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 11432059,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 7227174,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 6866037,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T19:00:01",
                until: "2024-11-22T11:58:00",
                duration: 3394798,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 6866032,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-10-16T12:47:00",
                until: "2024-11-22T11:58:29",
                duration: 393179,
                overallDuration: 3197489,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 6866043,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-09-11T19:00:04",
                until: "2024-11-22T11:58:03",
                duration: 3394795,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-993",
                from: "2024-10-16T12:46:58",
                until: "2024-11-22T11:58:26",
                duration: 393181,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T18:59:49",
                until: "2024-11-22T11:57:57",
                duration: 3394810,
                overallDuration: 6199088,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-10-16T12:46:51",
                until: "2024-11-22T11:58:17",
                duration: 393188,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-16T15:28:46",
                until: "2024-11-22T11:58:05",
                duration: 2975473,
                overallDuration: 5779759,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-10-16T12:46:55",
                until: "2024-11-22T11:58:21",
                duration: 393184,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 6866049,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-997",
                from: "2024-10-16T11:37:11",
                until: "2024-10-18T13:35:25",
                duration: 179894,
                overallDuration: 179894,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-996",
                from: "2024-10-15T12:11:10",
                until: "2024-10-16T11:36:59",
                duration: 84349,
                overallDuration: 84349,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-23T10:54:08",
                until: "2024-11-13T17:13:53",
                duration: 2387151,
                overallDuration: 4432785,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-993",
                from: "2024-10-12T13:14:12",
                until: "2024-10-16T12:46:58",
                duration: 343966,
                overallDuration: 343966,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-10-01T19:14:56",
                until: "2024-11-13T17:13:50",
                duration: 1665903,
                overallDuration: 3711534,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-09-17T17:28:24",
                until: "2024-10-16T12:46:55",
                duration: 2488711,
                overallDuration: 2488711,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-996",
                from: "2024-10-16T11:36:59",
                until: "2024-11-13T17:13:57",
                duration: 397380,
                overallDuration: 2443018,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-23T10:54:12",
                until: "2024-11-13T17:13:55",
                duration: 2387147,
                overallDuration: 4432783,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-15T12:11:04",
                until: "2024-10-16T12:47:04",
                duration: 88560,
                overallDuration: 88560,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-10-01T18:06:11",
                until: "2024-11-13T17:13:46",
                duration: 1670028,
                overallDuration: 3715655,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-09-20T13:07:33",
                until: "2024-10-16T12:47:00",
                duration: 2245167,
                overallDuration: 2245167,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-09-10T16:09:11",
                until: "2024-10-16T12:46:51",
                duration: 3098260,
                overallDuration: 3098260,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-997",
                from: "2024-10-18T13:35:25",
                until: "2024-11-13T17:13:37",
                duration: 217474,
                overallDuration: 2263092,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-02T12:52:26",
                until: "2024-10-15T12:11:04",
                duration: 1120718,
                overallDuration: 1120718,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-996",
                from: "2024-10-14T11:40:07",
                until: "2024-10-15T12:11:10",
                duration: 88263,
                overallDuration: 88263,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-997",
                from: "2024-10-16T11:34:51",
                until: "2024-10-16T11:37:11",
                duration: 140,
                overallDuration: 140,
                state: "To Do",
            },
        ],
    },
    {
        datetime: "2024-10-21 00:00:00",
        states: {
            "IN PROD": 5534857.95,
            "In Progress": 284167.5,
            "MERGED TO MASTER": 2306321.8,
            "Ready For QA": 601766.5,
            "To Do": 96677,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-16T12:47:04",
                until: "2024-11-22T11:58:32",
                duration: 997975,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 7470846,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 11095565,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-16T15:28:49",
                until: "2024-11-22T11:58:12",
                duration: 3580270,
                overallDuration: 5779763,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 7470840,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 10758461,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 12036859,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 7831974,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 7470837,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T19:00:01",
                until: "2024-11-22T11:58:00",
                duration: 3999598,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 7470832,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-10-16T12:47:00",
                until: "2024-11-22T11:58:29",
                duration: 997979,
                overallDuration: 3197489,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 7470843,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-09-11T19:00:04",
                until: "2024-11-22T11:58:03",
                duration: 3999595,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-993",
                from: "2024-10-16T12:46:58",
                until: "2024-11-22T11:58:26",
                duration: 997981,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T18:59:49",
                until: "2024-11-22T11:57:57",
                duration: 3999610,
                overallDuration: 6199088,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-10-16T12:46:51",
                until: "2024-11-22T11:58:17",
                duration: 997988,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-16T15:28:46",
                until: "2024-11-22T11:58:05",
                duration: 3580273,
                overallDuration: 5779759,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-10-16T12:46:55",
                until: "2024-11-22T11:58:21",
                duration: 997984,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 7470849,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-10-23T16:05:46",
                until: "2024-10-31T13:49:29",
                duration: 381253,
                overallDuration: 686623,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-998",
                from: "2024-10-21T12:07:38",
                until: "2024-10-23T16:05:40",
                duration: 187082,
                overallDuration: 187082,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-10-01T19:14:56",
                until: "2024-11-13T17:13:50",
                duration: 2270703,
                overallDuration: 3711534,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-996",
                from: "2024-10-16T11:36:59",
                until: "2024-11-13T17:13:57",
                duration: 1002180,
                overallDuration: 2443018,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-10-01T18:06:11",
                until: "2024-11-13T17:13:46",
                duration: 2274828,
                overallDuration: 3715655,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-23T10:54:12",
                until: "2024-11-13T17:13:55",
                duration: 2991947,
                overallDuration: 4432783,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-23T10:54:08",
                until: "2024-11-13T17:13:53",
                duration: 2991951,
                overallDuration: 4432785,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-998",
                from: "2024-10-23T16:05:40",
                until: "2024-11-13T17:13:41",
                duration: 381259,
                overallDuration: 1822081,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-997",
                from: "2024-10-18T13:35:25",
                until: "2024-11-13T17:13:37",
                duration: 822274,
                overallDuration: 2263092,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-10-21T11:15:42",
                until: "2024-10-23T16:05:46",
                duration: 190204,
                overallDuration: 190204,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-998",
                from: "2024-10-21T11:15:08",
                until: "2024-10-21T12:07:38",
                duration: 3150,
                overallDuration: 3150,
                state: "To Do",
            },
        ],
    },
    {
        datetime: "2024-10-28 00:00:00",
        states: {
            "IN PROD": 6139657.95,
            "In Progress": 452501,
            "MERGED TO MASTER": 2475839.8333333335,
            "Ready For QA": 1206566.5,
            "To Do": 154153,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 8075632,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 8075649,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-10-16T12:46:55",
                until: "2024-11-22T11:58:21",
                duration: 1602784,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-16T15:28:46",
                until: "2024-11-22T11:58:05",
                duration: 4185073,
                overallDuration: 5779759,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 11700365,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-10-16T12:47:00",
                until: "2024-11-22T11:58:29",
                duration: 1602779,
                overallDuration: 3197489,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-10-16T12:46:51",
                until: "2024-11-22T11:58:17",
                duration: 1602788,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T18:59:49",
                until: "2024-11-22T11:57:57",
                duration: 4604410,
                overallDuration: 6199088,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 8075640,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-16T15:28:49",
                until: "2024-11-22T11:58:12",
                duration: 4185070,
                overallDuration: 5779763,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 11363261,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 12641659,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-993",
                from: "2024-10-16T12:46:58",
                until: "2024-11-22T11:58:26",
                duration: 1602781,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 8436774,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-09-11T19:00:04",
                until: "2024-11-22T11:58:03",
                duration: 4604395,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 8075637,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 8075643,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T19:00:01",
                until: "2024-11-22T11:58:00",
                duration: 4604398,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-16T12:47:04",
                until: "2024-11-22T11:58:32",
                duration: 1602775,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 8075646,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1000",
                from: "2024-11-01T12:20:20",
                until: "2024-11-21T15:01:14",
                duration: 218379,
                overallDuration: 1737654,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-10-23T16:05:46",
                until: "2024-10-31T13:49:29",
                duration: 686623,
                overallDuration: 686623,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-23T10:54:08",
                until: "2024-11-13T17:13:53",
                duration: 3596751,
                overallDuration: 4432785,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-10-01T18:06:11",
                until: "2024-11-13T17:13:46",
                duration: 2879628,
                overallDuration: 3715655,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-10-31T13:49:29",
                until: "2024-11-13T17:14:02",
                duration: 299430,
                overallDuration: 1135473,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-10-01T19:14:56",
                until: "2024-11-13T17:13:50",
                duration: 2875503,
                overallDuration: 3711534,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-996",
                from: "2024-10-16T11:36:59",
                until: "2024-11-13T17:13:57",
                duration: 1606980,
                overallDuration: 2443018,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-23T10:54:12",
                until: "2024-11-13T17:13:55",
                duration: 3596747,
                overallDuration: 4432783,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-997",
                from: "2024-10-18T13:35:25",
                until: "2024-11-13T17:13:37",
                duration: 1427074,
                overallDuration: 2263092,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-998",
                from: "2024-10-23T16:05:40",
                until: "2024-11-13T17:13:41",
                duration: 986059,
                overallDuration: 1822081,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1000",
                from: "2024-10-30T17:31:07",
                until: "2024-11-01T12:20:20",
                duration: 154153,
                overallDuration: 154153,
                state: "To Do",
            },
        ],
    },
    {
        datetime: "2024-11-04 00:00:00",
        states: {
            "IN PROD": 6744457.95,
            "In Progress": 823179,
            "MERGED TO MASTER": 3080639.8333333335,
            "Ready For QA": 1811366.5,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 8680449,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-16T15:28:49",
                until: "2024-11-22T11:58:12",
                duration: 4789870,
                overallDuration: 5779763,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 8680440,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 11968061,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 13246459,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 9041574,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-993",
                from: "2024-10-16T12:46:58",
                until: "2024-11-22T11:58:26",
                duration: 2207581,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 8680437,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T19:00:01",
                until: "2024-11-22T11:58:00",
                duration: 5209198,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 8680432,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-10-16T12:47:00",
                until: "2024-11-22T11:58:29",
                duration: 2207579,
                overallDuration: 3197489,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 8680443,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-09-11T19:00:04",
                until: "2024-11-22T11:58:03",
                duration: 5209195,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-16T12:47:04",
                until: "2024-11-22T11:58:32",
                duration: 2207575,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 8680446,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-16T15:28:46",
                until: "2024-11-22T11:58:05",
                duration: 4789873,
                overallDuration: 5779759,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-10-16T12:46:55",
                until: "2024-11-22T11:58:21",
                duration: 2207584,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-10-16T12:46:51",
                until: "2024-11-22T11:58:17",
                duration: 2207588,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 12305165,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T18:59:49",
                until: "2024-11-22T11:57:57",
                duration: 5209210,
                overallDuration: 6199088,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1000",
                from: "2024-11-01T12:20:20",
                until: "2024-11-21T15:01:14",
                duration: 823179,
                overallDuration: 1737654,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-10-01T18:06:11",
                until: "2024-11-13T17:13:46",
                duration: 3484428,
                overallDuration: 3715655,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-23T10:54:08",
                until: "2024-11-13T17:13:53",
                duration: 4201551,
                overallDuration: 4432785,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-10-31T13:49:29",
                until: "2024-11-13T17:14:02",
                duration: 904230,
                overallDuration: 1135473,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-23T10:54:12",
                until: "2024-11-13T17:13:55",
                duration: 4201547,
                overallDuration: 4432783,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-996",
                from: "2024-10-16T11:36:59",
                until: "2024-11-13T17:13:57",
                duration: 2211780,
                overallDuration: 2443018,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-10-01T19:14:56",
                until: "2024-11-13T17:13:50",
                duration: 3480303,
                overallDuration: 3711534,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-998",
                from: "2024-10-23T16:05:40",
                until: "2024-11-13T17:13:41",
                duration: 1590859,
                overallDuration: 1822081,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-997",
                from: "2024-10-18T13:35:25",
                until: "2024-11-13T17:13:37",
                duration: 2031874,
                overallDuration: 2263092,
                state: "Ready For QA",
            },
        ],
    },
    {
        datetime: "2024-11-11 00:00:00",
        states: {
            "IN PROD": 5342421.535714285,
            "In Progress": 529967,
            "MERGED TO MASTER": 2025358.8,
            "Ready For QA": 2042586.5,
            "To Do": 70137.25,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 9285246,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-993",
                from: "2024-10-16T12:46:58",
                until: "2024-11-22T11:58:26",
                duration: 2812381,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-16T12:47:04",
                until: "2024-11-22T11:58:32",
                duration: 2812375,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 12572861,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 13851259,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 9646374,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1001",
                from: "2024-11-13T18:56:42",
                until: "2024-11-22T11:58:52",
                duration: 367397,
                overallDuration: 752530,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-996",
                from: "2024-11-13T17:13:57",
                until: "2024-11-22T11:58:47",
                duration: 373562,
                overallDuration: 758690,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 9285237,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T19:00:01",
                until: "2024-11-22T11:58:00",
                duration: 5813998,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 9285232,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-10-16T12:47:00",
                until: "2024-11-22T11:58:29",
                duration: 2812379,
                overallDuration: 3197489,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 9285243,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-09-11T19:00:04",
                until: "2024-11-22T11:58:03",
                duration: 5813995,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-11-13T17:13:46",
                until: "2024-11-22T11:58:35",
                duration: 373573,
                overallDuration: 758689,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-11-13T17:13:55",
                until: "2024-11-22T11:58:44",
                duration: 373564,
                overallDuration: 758689,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T18:59:49",
                until: "2024-11-22T11:57:57",
                duration: 5814010,
                overallDuration: 6199088,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-10-16T12:46:51",
                until: "2024-11-22T11:58:17",
                duration: 2812388,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-16T15:28:46",
                until: "2024-11-22T11:58:05",
                duration: 5394673,
                overallDuration: 5779759,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-11-13T17:14:02",
                until: "2024-11-13T17:14:14",
                duration: 12,
                overallDuration: 12,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-10-16T12:46:55",
                until: "2024-11-22T11:58:21",
                duration: 2812384,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 9285249,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-11-13T17:13:50",
                until: "2024-11-22T11:58:38",
                duration: 373569,
                overallDuration: 758688,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-997",
                from: "2024-11-13T18:56:38",
                until: "2024-11-22T11:58:49",
                duration: 367401,
                overallDuration: 752531,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 12909965,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-11-13T17:13:53",
                until: "2024-11-22T11:58:40",
                duration: 373566,
                overallDuration: 758687,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-16T15:28:49",
                until: "2024-11-22T11:58:12",
                duration: 5394670,
                overallDuration: 5779763,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 9285240,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1000",
                from: "2024-11-01T12:20:20",
                until: "2024-11-21T15:01:14",
                duration: 1427979,
                overallDuration: 1737654,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1002",
                from: "2024-11-14T09:34:23",
                until: "2024-11-19T11:14:50",
                duration: 314736,
                overallDuration: 438027,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1001",
                from: "2024-11-13T17:13:29",
                until: "2024-11-13T18:13:50",
                duration: 3621,
                overallDuration: 3621,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-11-13T17:14:27",
                until: "2024-11-18T09:49:55",
                duration: 373532,
                overallDuration: 405328,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-10-31T13:49:29",
                until: "2024-11-13T17:14:02",
                duration: 1135473,
                overallDuration: 1135473,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-09-23T10:54:12",
                until: "2024-11-13T17:13:55",
                duration: 4432783,
                overallDuration: 4432783,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-998",
                from: "2024-11-13T17:13:41",
                until: "2024-11-22T11:56:52",
                duration: 373578,
                overallDuration: 758591,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-996",
                from: "2024-10-16T11:36:59",
                until: "2024-11-13T17:13:57",
                duration: 2443018,
                overallDuration: 2443018,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1001",
                from: "2024-11-13T18:13:50",
                until: "2024-11-13T18:56:42",
                duration: 2572,
                overallDuration: 2572,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-11-13T17:14:14",
                until: "2024-11-13T17:14:23",
                duration: 9,
                overallDuration: 9,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-09-23T10:54:08",
                until: "2024-11-13T17:13:53",
                duration: 4432785,
                overallDuration: 4432785,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-997",
                from: "2024-11-13T17:13:37",
                until: "2024-11-13T18:56:38",
                duration: 6181,
                overallDuration: 6181,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-10-01T18:06:11",
                until: "2024-11-13T17:13:46",
                duration: 3715655,
                overallDuration: 3715655,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-10-01T19:14:56",
                until: "2024-11-13T17:13:50",
                duration: 3711534,
                overallDuration: 3711534,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-998",
                from: "2024-10-23T16:05:40",
                until: "2024-11-13T17:13:41",
                duration: 1822081,
                overallDuration: 1822081,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-997",
                from: "2024-10-18T13:35:25",
                until: "2024-11-13T17:13:37",
                duration: 2263092,
                overallDuration: 2263092,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1003",
                from: "2024-11-15T16:53:43",
                until: "2024-11-18T09:50:01",
                duration: 201976,
                overallDuration: 233778,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1002",
                from: "2024-11-13T14:56:49",
                until: "2024-11-14T09:34:23",
                duration: 67054,
                overallDuration: 67054,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1001",
                from: "2024-11-13T14:01:34",
                until: "2024-11-13T17:13:29",
                duration: 11515,
                overallDuration: 11515,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-11-13T17:14:23",
                until: "2024-11-13T17:14:27",
                duration: 4,
                overallDuration: 4,
                state: "To Do",
            },
        ],
    },
    {
        datetime: "2024-11-18 00:00:00",
        states: {
            "IN PROD": 5006425.0625,
            "In Progress": 661419.5,
            "MERGED TO MASTER": 325437.2,
            "Ready For QA": 38770,
            "To Do": 79607.33333333333,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-994",
                from: "2024-10-16T12:47:04",
                until: "2024-11-22T11:58:32",
                duration: 3197488,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-974",
                from: "2024-08-02T14:45:53",
                until: "2024-11-22T11:57:43",
                duration: 9670310,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-997",
                from: "2024-11-13T18:56:38",
                until: "2024-11-22T11:58:49",
                duration: 752531,
                overallDuration: 752531,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-996",
                from: "2024-11-13T17:13:57",
                until: "2024-11-22T11:58:47",
                duration: 758690,
                overallDuration: 758690,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-977",
                from: "2024-08-02T14:46:02",
                until: "2024-11-22T11:57:52",
                duration: 9670310,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-981",
                from: "2024-09-11T19:00:01",
                until: "2024-11-22T11:58:00",
                duration: 6199079,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-969",
                from: "2024-08-02T14:46:07",
                until: "2024-11-22T11:57:55",
                duration: 9670308,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-990",
                from: "2024-10-16T12:47:00",
                until: "2024-11-22T11:58:29",
                duration: 3197489,
                overallDuration: 3197489,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1002",
                from: "2024-11-22T11:57:04",
                until: "2024-11-22T11:59:05",
                duration: 121,
                overallDuration: 121,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-975",
                from: "2024-08-02T14:45:56",
                until: "2024-11-22T11:57:46",
                duration: 9670310,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-979",
                from: "2024-09-11T19:00:04",
                until: "2024-11-22T11:58:03",
                duration: 6199079,
                overallDuration: 6199079,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-998",
                from: "2024-11-22T11:56:52",
                until: "2024-11-22T11:58:57",
                duration: 125,
                overallDuration: 125,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-989",
                from: "2024-11-13T17:13:46",
                until: "2024-11-22T11:58:35",
                duration: 758689,
                overallDuration: 758689,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-988",
                from: "2024-11-13T17:13:55",
                until: "2024-11-22T11:58:44",
                duration: 758689,
                overallDuration: 758689,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-11-22T11:57:07",
                until: "2024-11-22T11:59:08",
                duration: 121,
                overallDuration: 121,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-993",
                from: "2024-10-16T12:46:58",
                until: "2024-11-22T11:58:26",
                duration: 3197488,
                overallDuration: 3197488,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-944",
                from: "2024-09-11T18:59:49",
                until: "2024-11-22T11:57:57",
                duration: 6199088,
                overallDuration: 6199088,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-976",
                from: "2024-10-16T12:46:51",
                until: "2024-11-22T11:58:17",
                duration: 3197486,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-992",
                from: "2024-11-13T17:13:50",
                until: "2024-11-22T11:58:38",
                duration: 758688,
                overallDuration: 758688,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-972",
                from: "2024-08-02T14:45:50",
                until: "2024-11-22T11:57:38",
                duration: 9670308,
                overallDuration: 9670308,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-983",
                from: "2024-10-16T12:46:55",
                until: "2024-11-22T11:58:21",
                duration: 3197486,
                overallDuration: 3197486,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-985",
                from: "2024-09-16T15:28:46",
                until: "2024-11-22T11:58:05",
                duration: 5779759,
                overallDuration: 5779759,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-968",
                from: "2024-06-21T15:53:54",
                until: "2024-11-22T11:57:31",
                duration: 13295017,
                overallDuration: 13295017,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-987",
                from: "2024-11-13T17:13:53",
                until: "2024-11-22T11:58:40",
                duration: 758687,
                overallDuration: 758687,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-984",
                from: "2024-09-16T15:28:49",
                until: "2024-11-22T11:58:12",
                duration: 5779763,
                overallDuration: 5779763,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-973",
                from: "2024-08-02T14:45:59",
                until: "2024-11-22T11:57:49",
                duration: 9670310,
                overallDuration: 9670310,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1005",
                from: "2024-11-22T11:56:56",
                until: "2024-11-22T11:59:02",
                duration: 126,
                overallDuration: 126,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-961",
                from: "2024-06-25T13:32:18",
                until: "2024-11-22T11:57:23",
                duration: 12957905,
                overallDuration: 12957905,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-960",
                from: "2024-06-10T18:25:40",
                until: "2024-11-22T11:59:14",
                duration: 14236414,
                overallDuration: 14236414,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1000",
                from: "2024-11-22T11:57:01",
                until: "2024-11-25T14:50:06",
                duration: 219778,
                overallDuration: 269585,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-971",
                from: "2024-07-29T10:27:05",
                until: "2024-11-22T11:57:35",
                duration: 10031430,
                overallDuration: 10031430,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1001",
                from: "2024-11-13T18:56:42",
                until: "2024-11-22T11:58:52",
                duration: 752530,
                overallDuration: 752530,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1005",
                from: "2024-11-18T18:55:25",
                until: "2024-11-19T12:53:14",
                duration: 64669,
                overallDuration: 64669,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1002",
                from: "2024-11-14T09:34:23",
                until: "2024-11-19T11:14:50",
                duration: 438027,
                overallDuration: 438027,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-11-13T17:14:27",
                until: "2024-11-18T09:49:55",
                duration: 405328,
                overallDuration: 405328,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1000",
                from: "2024-11-01T12:20:20",
                until: "2024-11-21T15:01:14",
                duration: 1737654,
                overallDuration: 1737654,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1000",
                from: "2024-11-22T08:51:12",
                until: "2024-11-22T11:57:01",
                duration: 11149,
                overallDuration: 11149,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1005",
                from: "2024-11-19T12:53:14",
                until: "2024-11-22T11:56:56",
                duration: 255822,
                overallDuration: 255822,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-998",
                from: "2024-11-13T17:13:41",
                until: "2024-11-22T11:56:52",
                duration: 758591,
                overallDuration: 758591,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-999",
                from: "2024-11-18T09:49:55",
                until: "2024-11-22T11:57:07",
                duration: 353232,
                overallDuration: 353232,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1002",
                from: "2024-11-19T14:57:12",
                until: "2024-11-22T11:57:04",
                duration: 248392,
                overallDuration: 248392,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1002",
                from: "2024-11-19T11:14:50",
                until: "2024-11-19T14:57:12",
                duration: 13342,
                overallDuration: 13342,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1000",
                from: "2024-11-21T15:01:14",
                until: "2024-11-22T08:51:12",
                duration: 64198,
                overallDuration: 64198,
                state: "Ready For QA",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1006",
                from: "2024-11-22T09:45:25",
                until: "2024-11-22T09:45:38",
                duration: 13,
                overallDuration: 13,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1005",
                from: "2024-11-18T17:31:34",
                until: "2024-11-18T18:55:25",
                duration: 5031,
                overallDuration: 5031,
                state: "To Do",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1003",
                from: "2024-11-15T16:53:43",
                until: "2024-11-18T09:50:01",
                duration: 233778,
                overallDuration: 233778,
                state: "To Do",
            },
        ],
    },
    {
        datetime: "2024-11-25 00:00:00",
        states: {
            "IN PROD": 134794,
            "In Progress": 951,
            "MERGED TO MASTER": 1060,
            "To Do": 1910,
        },
        details: [
            {
                url: "https://adadot.atlassian.net/browse/MVP-1007",
                from: "2024-11-25T12:57:10",
                until: "2024-11-25T12:57:13",
                duration: 3,
                overallDuration: 3,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1000",
                from: "2024-11-22T11:57:01",
                until: "2024-11-25T14:50:06",
                duration: 269585,
                overallDuration: 269585,
                state: "IN PROD",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1007",
                from: "2024-11-25T12:23:39",
                until: "2024-11-25T12:39:30",
                duration: 951,
                overallDuration: 951,
                state: "In Progress",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1007",
                from: "2024-11-25T12:39:30",
                until: "2024-11-25T12:57:10",
                duration: 1060,
                overallDuration: 1060,
                state: "MERGED TO MASTER",
            },
            {
                url: "https://adadot.atlassian.net/browse/MVP-1007",
                from: "2024-11-25T11:51:49",
                until: "2024-11-25T12:23:39",
                duration: 1910,
                overallDuration: 1910,
                state: "To Do",
            },
        ],
    },
];

const ticketsBreakdown = [
    {
        status: "To Do",
        total: 5,
        issues: [
            {
                type: "Subtask",
                value: 1,
            },
            {
                type: "Task",
                value: 4,
            },
            {
                type: "Bug",
                value: 1,
            },
        ],
    },
    {
        status: "In Progress",
        total: 5,
        issues: [
            {
                type: "Task",
                value: 1,
            },
            {
                type: "Feature",
                value: 1,
            },
        ],
    },
    {
        status: "Done",
        total: 5,
        issues: [
            {
                type: "Subtask",
                value: 1,
            },
            {
                type: "Task",
                value: 4,
            },
        ],
    },
];

const ticketsBreakdownExpanded = [
    {
        status: "To Do",
        total: 3,
        issues: [
            {
                type: "Subtask",
                value: 1,
            },
            {
                type: "Task",
                value: 2,
            },
        ],
    },
    {
        status: "Assigned",
        total: 3,
        issues: [
            {
                type: "Subtask",
                value: 1,
            },
            {
                type: "Task",
                value: 2,
            },
        ],
    },
    {
        status: "Merged to Sit",
        total: 3,
        issues: [
            {
                type: "Subtask",
                value: 1,
            },
            {
                type: "Task",
                value: 2,
            },
        ],
    },
    {
        status: "Merged to Master",
        total: 3,
        issues: [
            {
                type: "Subtask",
                value: 1,
            },
            {
                type: "Task",
                value: 2,
            },
        ],
    },
    {
        status: "Done",
        total: 3,
        issues: [
            {
                type: "Subtask",
                value: 1,
            },
            {
                type: "Task",
                value: 2,
            },
        ],
    },
];

const ticketsAdded = [
    {
        datetime: "2024-05-03 00:00:00",
        Tickets: {
            issues: 0,
            points: 1,
            color: null,
        },
    },
    {
        datetime: "2024-05-04 00:00:00",
        Tickets: {
            issues: 2,
            points: 1,
            color: null,
        },
    },
    {
        datetime: "2024-05-05 00:00:00",
        Tickets: {
            issues: 0,
            points: 0,
            color: null,
        },
    },
    {
        datetime: "2024-05-06 00:00:00",
        Tickets: {
            issues: 1,
            points: 0,
            color: null,
        },
    },
    {
        datetime: "2024-05-07 00:00:00",
        Tickets: {
            issues: 2,
            points: 0,
            color: null,
        },
    },
    {
        datetime: "2024-05-08 00:00:00",
        Tickets: {
            issues: 0,
            points: 0,
            color: null,
        },
    },
    {
        datetime: "2024-05-09 00:00:00",
        Task: {
            issues: 2,
            points: 0,
            color: null,
        },
    },
];

const ticketsAssigned = [
    {
        day: "Sunday",
        min: {
            issues: 0,
            points: 0,
        },
        max: {
            issues: 0,
            points: 0,
        },
    },
    {
        day: "Monday",
        min: {
            issues: 1,
            points: 1,
        },
        max: {
            issues: 1,
            points: 1,
        },
    },
    {
        day: "Tuesday",
        min: {
            issues: 1,
            points: 0,
        },
        max: {
            issues: 4,
            points: 0,
        },
    },
    {
        day: "Wednesday",
        min: {
            issues: 1,
            points: 0,
        },
        max: {
            issues: 3,
            points: 0,
        },
    },
    {
        day: "Thursday",
        min: {
            issues: 2,
            points: 0,
        },
        max: {
            issues: 2,
            points: 3,
        },
    },
    {
        day: "Friday",
        min: {
            issues: 0,
            points: 0,
        },
        max: {
            issues: 5,
            points: 0,
        },
    },
    {
        day: "Saturday",
        min: {
            issues: 0,
            points: 0,
        },
        max: {
            issues: 0,
            points: 0,
        },
    },
];

const workDistribution = [
    {
        name: "Task",
        value: {
            issues: 15,
            points: 3,
            timeSpent: 1389,
            ticketsTimeSpent: 2,
        },
    },
    {
        name: "Features",
        value: {
            issues: 9,
            points: 5,
            timeSpent: 5339,
            ticketsTimeSpent: 1,
        },
    },
    {
        name: "Bugs",
        value: {
            issues: 3,
            points: 1,
            timeSpent: 3389,
            ticketsTimeSpent: 2,
        },
    },
];

const stuckTickets = [
    {
        name: "MVP-703",
        title: "BE - Handle Github Draft PRs",
        url: "https://api.atlassian.com/ex/jira/8b8e0dd5-aaf8-4bea-bdfc-e236d6e7a7ce/rest/api/3/issue/10005",
        type: "Task",
        startDate: "2022-11-01 10:52:36",
    },
    {
        name: "MVP-711",
        title: "BE - Graph network discovery",
        url: "https://api.atlassian.com/ex/jira/8b8e0dd5-aaf8-4bea-bdfc-e236d6e7a7ce/rest/api/3/issue/10005",
        type: "Task",
        startDate: "2022-11-07 15:54:21",
    },
    {
        name: "MVP-678",
        title: "BE - Added/deleted/changed from commits",
        url: "https://api.atlassian.com/ex/jira/8b8e0dd5-aaf8-4bea-bdfc-e236d6e7a7ce/rest/api/3/issue/10005",
        type: "Task",
        startDate: "2022-10-10 10:02:06",
    },
];

const bugs = [
    {
        datetime: "2024-01-01 00:00:00",
        environment: "No Environment",
        created_count: 151,
        done_count: 134,
        in_backlog_count: 17,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 10,
        done_count: 10,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: null,
        created_count: 170,
        done_count: 153,
        in_backlog_count: 17,
    },
    {
        datetime: "2024-01-01 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: null,
        created_count: 171,
        done_count: 157,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "No Environment",
        created_count: 152,
        done_count: 138,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-08 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 10,
        done_count: 10,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: null,
        created_count: 177,
        done_count: 161,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 10,
        done_count: 10,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-15 00:00:00",
        environment: "No Environment",
        created_count: 158,
        done_count: 142,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: null,
        created_count: 177,
        done_count: 167,
        in_backlog_count: 10,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "No Environment",
        created_count: 158,
        done_count: 148,
        in_backlog_count: 10,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 10,
        done_count: 10,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-22 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 10,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: null,
        created_count: 180,
        done_count: 167,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "No Environment",
        created_count: 160,
        done_count: 148,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-01-29 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "No Environment",
        created_count: 163,
        done_count: 150,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: null,
        created_count: 183,
        done_count: 170,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 11,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-05 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 11,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "No Environment",
        created_count: 166,
        done_count: 151,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: null,
        created_count: 186,
        done_count: 171,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-12 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "No Environment",
        created_count: 169,
        done_count: 158,
        in_backlog_count: 11,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: null,
        created_count: 189,
        done_count: 178,
        in_backlog_count: 11,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 11,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-19 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "No Environment",
        created_count: 171,
        done_count: 160,
        in_backlog_count: 11,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: null,
        created_count: 191,
        done_count: 180,
        in_backlog_count: 11,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 11,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-02-26 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 11,
        done_count: 11,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: null,
        created_count: 196,
        done_count: 181,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "No Environment",
        created_count: 176,
        done_count: 161,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-03-04 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: null,
        created_count: 199,
        done_count: 186,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "No Environment",
        created_count: 178,
        done_count: 165,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-11 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "Pre-Release",
        created_count: 5,
        done_count: 5,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "No Environment",
        created_count: 185,
        done_count: 166,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: null,
        created_count: 206,
        done_count: 187,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-18 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "No Environment",
        created_count: 187,
        done_count: 173,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: null,
        created_count: 209,
        done_count: 194,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-03-25 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: null,
        created_count: 210,
        done_count: 194,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "No Environment",
        created_count: 188,
        done_count: 173,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-01 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "No Environment",
        created_count: 196,
        done_count: 178,
        in_backlog_count: 18,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: null,
        created_count: 218,
        done_count: 199,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-04-08 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "No Environment",
        created_count: 198,
        done_count: 178,
        in_backlog_count: 20,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: null,
        created_count: 220,
        done_count: 199,
        in_backlog_count: 21,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-15 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: null,
        created_count: 223,
        done_count: 204,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-22 00:00:00",
        environment: "No Environment",
        created_count: 201,
        done_count: 183,
        in_backlog_count: 18,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "No Environment",
        created_count: 201,
        done_count: 190,
        in_backlog_count: 11,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: null,
        created_count: 223,
        done_count: 211,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-04-29 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: null,
        created_count: 228,
        done_count: 212,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 5,
        in_backlog_count: 1,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "No Environment",
        created_count: 206,
        done_count: 191,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-06 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "No Environment",
        created_count: 207,
        done_count: 192,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-13 00:00:00",
        environment: null,
        created_count: 229,
        done_count: 214,
        in_backlog_count: 15,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: null,
        created_count: 231,
        done_count: 217,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "No Environment",
        created_count: 209,
        done_count: 195,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-05-20 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "No Environment",
        created_count: 213,
        done_count: 201,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-05-27 00:00:00",
        environment: null,
        created_count: 235,
        done_count: 223,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "No Environment",
        created_count: 219,
        done_count: 207,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: null,
        created_count: 241,
        done_count: 229,
        in_backlog_count: 12,
    },
    {
        datetime: "2024-06-03 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: null,
        created_count: 243,
        done_count: 230,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "No Environment",
        created_count: 221,
        done_count: 208,
        in_backlog_count: 13,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-10 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: null,
        created_count: 245,
        done_count: 231,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "No Environment",
        created_count: 223,
        done_count: 209,
        in_backlog_count: 14,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-17 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: null,
        created_count: 249,
        done_count: 233,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "No Environment",
        created_count: 227,
        done_count: 211,
        in_backlog_count: 16,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-06-24 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "No Environment",
        created_count: 232,
        done_count: 215,
        in_backlog_count: 17,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: null,
        created_count: 254,
        done_count: 237,
        in_backlog_count: 17,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-01 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "No Environment",
        created_count: 235,
        done_count: 216,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-08 00:00:00",
        environment: null,
        created_count: 257,
        done_count: 238,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: null,
        created_count: 260,
        done_count: 242,
        in_backlog_count: 18,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "No Environment",
        created_count: 238,
        done_count: 220,
        in_backlog_count: 18,
    },
    {
        datetime: "2024-07-15 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "Staging",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: null,
        created_count: 261,
        done_count: 242,
        in_backlog_count: 19,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "Daily",
        created_count: 1,
        done_count: 1,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "Pre-Release",
        created_count: 6,
        done_count: 6,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "Production (Customer Reported)",
        created_count: 2,
        done_count: 2,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "Production (Internally Reported)",
        created_count: 12,
        done_count: 12,
        in_backlog_count: 0,
    },
    {
        datetime: "2024-07-22 00:00:00",
        environment: "No Environment",
        created_count: 239,
        done_count: 220,
        in_backlog_count: 19,
    },
];

const timeSpentEstimated = {
    timeSpentToDo: 83400,
    timeSpentInProgress: 543000,
    timeEstimatedInProgress: 10800,
    timeEstimatedToDo: 28800,
    timeSpentDone: 1158660,
    timeEstimatedDone: 50400,
    timeSpentAll: 1785060,
    timeEstimatedAll: 90000,
    underEstimatedSum: 49800,
    underEstimatedCount: 2,
    underEstimatedAvg: 24900,
    tickets: [
        {
            issueKey: "ISSUE-001",
            timeSpent: null,
            timeEstimated: 28800,
            summary: "Content configuration update",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-001",
            type: "Story",
            status: "To Do",
        },
        {
            issueKey: "ISSUE-002",
            timeSpent: 14700,
            timeEstimated: 0,
            summary: "SEO metadata adjustments",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-002",
            type: "Story",
            status: "To Do",
        },
        {
            issueKey: "ISSUE-003",
            timeSpent: 10800,
            timeEstimated: 0,
            summary: "UI widget enhancement",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-003",
            type: "Story",
            status: "To Do",
        },
        {
            issueKey: "ISSUE-004",
            timeSpent: 39960,
            timeEstimated: 0,
            summary: "Core module implementation",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-004",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-005",
            timeSpent: 129600,
            timeEstimated: 0,
            summary: "Content publishing feature",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-005",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-006",
            timeSpent: 38700,
            timeEstimated: 0,
            summary: "Category management logic",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-006",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-007",
            timeSpent: 99900,
            timeEstimated: 0,
            summary: "Scheduling system enhancement",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-007",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-008",
            timeSpent: 71100,
            timeEstimated: 0,
            summary: "Author profile feature",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-008",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-009",
            timeSpent: 900,
            timeEstimated: 0,
            summary: "Guides content support",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-009",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-010",
            timeSpent: 15600,
            timeEstimated: 0,
            summary: "Press release workflow",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-010",
            type: "Story",
            status: "In Progress",
        },
        {
            issueKey: "ISSUE-011",
            timeSpent: 64800,
            timeEstimated: 50400,
            summary: "Infrastructure setup task",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-011",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-012",
            timeSpent: 158400,
            timeEstimated: 0,
            summary: "Data integration feature",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-012",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-013",
            timeSpent: 93600,
            timeEstimated: 0,
            summary: "Promotional content module",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-013",
            type: "Story",
            status: "In Progress",
        },
        {
            issueKey: "ISSUE-014",
            timeSpent: 138000,
            timeEstimated: 0,
            summary: "Editorial layout feature",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-014",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-015",
            timeSpent: 28200,
            timeEstimated: 0,
            summary: "Fixtures data integration",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-015",
            type: "Story",
            status: "In Progress",
        },
        {
            issueKey: "ISSUE-016",
            timeSpent: 19200,
            timeEstimated: 0,
            summary: "Regional page generation",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-016",
            type: "Story",
            status: "In Progress",
        },
        {
            issueKey: "ISSUE-017",
            timeSpent: 55800,
            timeEstimated: 0,
            summary: "Prediction content feature",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-017",
            type: "Story",
            status: "In Progress",
        },
        {
            issueKey: "ISSUE-018",
            timeSpent: 39000,
            timeEstimated: 0,
            summary: "System configuration update",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-018",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-019",
            timeSpent: 72000,
            timeEstimated: 0,
            summary: "Landing page templates",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-019",
            type: "Story",
            status: "In Progress",
        },
        {
            issueKey: "ISSUE-020",
            timeSpent: 61500,
            timeEstimated: 0,
            summary: "Newsletter configuration",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-020",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-021",
            timeSpent: 10200,
            timeEstimated: 0,
            summary: "External feed defect",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-021",
            type: "Bug",
            status: "To Do",
        },
        {
            issueKey: "ISSUE-022",
            timeSpent: 46200,
            timeEstimated: 10800,
            summary: "URL handling service",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-022",
            type: "Story",
            status: "In Progress",
        },
        {
            issueKey: "ISSUE-023",
            timeSpent: 600,
            timeEstimated: 0,
            summary: "Data persistence bug",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-023",
            type: "Bug",
            status: "Done",
        },
        {
            issueKey: "ISSUE-024",
            timeSpent: 116100,
            timeEstimated: 0,
            summary: "Media content publishing",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-024",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-025",
            timeSpent: 43500,
            timeEstimated: 0,
            summary: "Frontend formatting update",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-025",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-026",
            timeSpent: 4500,
            timeEstimated: 0,
            summary: "Domain migration task",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-026",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-027",
            timeSpent: 47700,
            timeEstimated: 0,
            summary: "Reusable UI components",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-027",
            type: "Story",
            status: "To Do",
        },
        {
            issueKey: "ISSUE-028",
            timeSpent: 121800,
            timeEstimated: 0,
            summary: "Content shortcode system",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-028",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-029",
            timeSpent: 212400,
            timeEstimated: 0,
            summary: "Legacy feature migration",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-029",
            type: "Story",
            status: "In Progress",
        },
        {
            issueKey: "ISSUE-030",
            timeSpent: 15300,
            timeEstimated: 0,
            summary: "API endpoint update",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-030",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-031",
            timeSpent: 9000,
            timeEstimated: 0,
            summary: "Staging environment defect",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-031",
            type: "Bug",
            status: "Done",
        },
        {
            issueKey: "ISSUE-032",
            timeSpent: 1800,
            timeEstimated: 0,
            summary: "Branding asset issue",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-032",
            type: "Bug",
            status: "Done",
        },
        {
            issueKey: "ISSUE-033",
            timeSpent: 1800,
            timeEstimated: 0,
            summary: "Temporary branding update",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-033",
            type: "Story",
            status: "Done",
        },
        {
            issueKey: "ISSUE-034",
            timeSpent: 2400,
            timeEstimated: 0,
            summary: "Temporary visual assets update",
            issueUrl: "https://example.atlassian.net/browse/ISSUE-034",
            type: "Story",
            status: "Done",
        },
    ],
};

const meta = {
    inactive: false,
    lastActiveAt: 1653523200,
    firstScrappedDate: 1650412800,
};

const stats = {
    backlogSize: {
        issues: 7,
        points: null,
    },
    ticketsTransitioned: {
        uniqueIssues: 4,
        transitions: {
            issues: 9,
            points: 0,
        },
    },
    arrivalRate: {
        issues: 0.29,
        points: 0,
    },
    departureRate: {
        issues: 0.29,
        points: 0,
    },
    avgCycleTime: 2825943,
    avgThroughput: {
        issues: 2,
        points: 0,
    },
};

const statsBaseline = {
    backlogSize: {
        issues: 18.93,
        points: 0,
    },
    ticketsTransitioned: {
        uniqueIssues: 3.53,
        transitions: {
            issues: 6.47,
            points: 0,
        },
    },
    arrivalRate: {
        issues: 0.11,
        points: 0,
    },
    departureRate: {
        issues: 0.2,
    },
    avgCycleTime: 2898811.85,
    avgThroughput: {
        issues: 1.17,
        points: 0,
    },
};

const getSprintBreakdown = () => {
    return {
        ticketsAssigned,
        timeSpentEstimated,
        stuckTickets,
        ticketsOverview,
        workDistribution,
        ticketsAdded,
        ticketsBreakdown: {
            simple: ticketsBreakdown,
            expanded: ticketsBreakdownExpanded,
        },
        timeStateDuration,
        bugs,
        stats,
        statsBaseline,
        meta,
    };
};

export default getSprintBreakdown;
